import { fixBaseURL } from "./fixBaseURL";
import type { MontaLinkProps } from "./types";
import { Link as LinkReact } from "./reactRouterDom";

function omit<T, K extends keyof T>(obj: T, ...keys: K[]): Omit<T, K> {
  const result = { ...obj };
  keys.forEach((key) => delete result[key]);
  return result;
}

export const MontaLink = function (props: MontaLinkProps) {
  const { to, baseURL } = props;
  const newProps = { ...props };
  if (baseURL && to) newProps.to = fixBaseURL(to.toString(), baseURL);
  if (newProps.to.toString().startsWith("http")) {
    const anchorProps = omit(
      newProps,
      "reloadDocument",
      "replace",
      "state",
      "preventScrollReset",
      "relative",
      "to",
    ) as MontaLinkProps & { href: string };
    anchorProps.href = newProps.to.toString();
    return <a {...anchorProps} />;
  } else {
    return <LinkReact {...newProps} />;
  }
};
